import { useState } from "react";
import { isMobileOnly } from "react-device-detect";
import { layers, intialLayer } from "./layers";
import { markers } from "./markers";
import { MarkerModalProvider } from "./context/MarkerModal";
import StartModal from "./components/StartModal";
import IconGPS from "./components/IconGPS";
import Controls from "./components/Controls";
import Map from "./components/Map";
import MarkerModal from "./components/MarkerModal";
import Info from "./components/Info";
import Slideshow from "./components/Slideshow";

function App() {
  const [activeLayer, setActiveLayer] = useState(intialLayer);
  const [ready, setReady] = useState(false);

  return (
    <>
      {isMobileOnly && (
        <>
          {!ready ? (
            <StartModal setReady={() => setReady(true)} />
          ) : (
            <>
              <IconGPS />
              <Controls
                activeLayer={activeLayer}
                setActiveLayer={setActiveLayer}
              />
              <MarkerModalProvider>
                <MarkerModal />
                <Map
                  layers={layers}
                  activeLayer={activeLayer}
                  markers={markers}
                />
              </MarkerModalProvider>
            </>
          )}
        </>
      )}
      {!isMobileOnly && (
        <>
          <p className="desktop-subtitle">
            Dear wanderer, please visit me from your phone…
          </p>
          <Slideshow />
        </>
      )}
      <Info />
    </>
  );
}

export default App;
